// DEPRECATED: replaced by OnboardingShell
import React from "react";
import { Stack } from "@mui/material";

interface ContentAreaWrapperProps {
    children: React.ReactNode;
    fullyScrollable?: boolean; // Determines scroll behavior for the wrapper
    headerType?: "main" | "tab" | "none"; // Determines top padding
    noFooter?: boolean; // Disables bottom padding
    stickyBottomButton?: boolean; // Enlarges bottom padding
}

const ContentAreaWrapper: React.FC<ContentAreaWrapperProps> = ({
    children,
    fullyScrollable = true,
    headerType = "main",
    noFooter = false,
    stickyBottomButton = false,
}) => {
    const paddingTop = {
        main: "64px",
        tab: "20px",
        none: 0,
    };

    const calculatePb = (
        footer: boolean,
        stickyBottomButton: boolean
    ): string => {
        const basicPb = "4vh";
        const footerSize = "90px";
        const bottomButtonSize = "16vh";

        const parts = [basicPb];
        if (footer) parts.push(footerSize);
        if (stickyBottomButton) parts.push(bottomButtonSize);

        return `calc(${parts.join(" + ")})`;
    };

    return (
        <Stack
            direction="column"
            width="100%"
            height="100%"
            justifyContent="start"
            alignItems="center"
            spacing={2}
            sx={{
                overflowY: fullyScrollable ? "auto" : "hidden",
                paddingTop: paddingTop[headerType], // Add space for the fixed header
                paddingBottom: calculatePb(!noFooter, stickyBottomButton),
            }}
        >
            {children}
        </Stack>
    );
};

export default ContentAreaWrapper;
